module.exports = __webpack_public_path__ + "static/media/new-home-icon.0182ac51.svg";